import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import './Logo.css';

const Logo = () => {
  return (
    <Link to="/" className="no-underline">
      <motion.div 
        className="logo-container"
        // whileHover={{ scale: 1.05 }}
        // transition={{ type: "spring", stiffness: 400, damping: 10 }}
      >
        <div className="logo-icon">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="icon"
          >
            <path
              d="M12 4L20 12L12 20L4 12L12 4Z"
              fill="currentColor"
              fillOpacity="0.2"
            />
            <path
              d="M12 8L16 12L12 16L8 12L12 8Z"
              fill="currentColor"
            />
          </svg>
        </div>
        <h1 className="logo">
          <span className="logo-text">zilean</span>
          <span className="logo-dot">.</span>
        </h1>
      </motion.div>
    </Link>
  );
};

export default Logo; 